<template>
  <div>
    <span>{{ showContent }}</span>
    <el-button v-if="isMore" class="m-l-8 p-t-0 p-b-0" type="text" @click="handleClick">{{ isExpand ? '收起' : '查看更多' }}</el-button>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * 默认是否展开状态
     */
    isDefaultExpand: {
      type: Boolean,
      default: false
    },

    /**
     * 最大长度
     */
    maxLength: {
      type: Number,
      default: 200
    },

    content: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 当前是否展开
      isExpand: false
    }
  },

  computed: {
    showContent() {
      return this.isExpand ? this.content : `${this.content.slice(0, this.maxLength)}${this.isMore ? '...' : ''}`
    },

    /**
     * 是否展示查看更多/收起按钮
     */
    isMore() {
      return this.content?.length > this.maxLength
    }
  },

  mounted() {
    this.isExpand = this.isDefaultExpand
  },

  methods: {
    handleClick() {
      this.isExpand = !this.isExpand
    }
  }
}
</script>

<style>

</style>